import React, { memo } from "react";
import { Modal } from "antd";
import style from "./style.module.scss";
import CFCLogo from "../../../../../assets/images/ClimateFinanceCopilotLogo.svg";
import { useNavigate } from "react-router-dom";

interface modalProps {
  open?: any;
  setOpenModal?: (val: any) => void;
}

const SignupTrialModal: React.FC<modalProps> = ({ open, setOpenModal }) => {
  const navigate = useNavigate();

  const handleAIAssistant = () => {
    localStorage.setItem("showInfoModal", "false");
    setOpenModal?.(false);
  };

  const handlePlayground = async () => {
    localStorage.setItem("showInfoModal", "false");
    navigate("/playground/");
  };

  return (
    <Modal
      width={675}
      title=""
      footer={null}
      open={open}
      centered
      onCancel={handleAIAssistant}
      styles={{
        content: {
          padding: 0,
          borderRadius: "0px",
          overflow: "hidden",
        },
      }}
    >
      <div className={style.header}>
        <img
          src={CFCLogo}
          alt="Climate Finance Copilot Logo"
          className={style.logo}
        />
      </div>

      <div className={style.content}>
        <h2 className={style.title}>Welcome to Climate Finance Copilot!</h2>

        <ul className={style.list}>
          <li>
            <b>
              The all-in-one platform for unlocking climate finance faster, more
              securely, and with greater confidence. Before you dive in, take
              note of a few important details:
            </b>
          </li>
          <li>
            <b>Concept Note Assistants: </b>
            When your Concept Note is nearly complete, use the appropriate
            Assistant to run a full analysis. To use an Assistant such as the
            ‘Concept Note Evaluator’ click on the ‘Go to Assistants’ button
            below and select the New Project tile.
          </li>
          <li>
            <b>Credit System:</b> Use of Copilot is linked to a credit/token
            system. All new users are allocated <b>80 credits</b> to use across
            all tools. Once those credits are exhausted, you will be prompted to
            purchase additional credits.
          </li>
          <li>
            We hope you enjoy your experience using Copilot - the most powerful,
            data secure AI software customized just for you!
          </li>
        </ul>

        {/* <p>
          We hope you enjoy your experience using Copilot – the most powerful,
          data-secure AI software customized just for you!
        </p> */}
      </div>

      <div className={style.footer}>
        <button onClick={handleAIAssistant} className={style.aiButton}>
          Go to Assistants
        </button>
        {/*<button onClick={handlePlayground} className={style.pgButton}>*/}
        {/*  Go to Playground*/}
        {/*</button>*/}
      </div>
    </Modal>
  );
};

export default memo(SignupTrialModal);
